<template>
  <div class='__boxRoot__JC' :class='[boxClass]'>
    <div class='__birdRoot__JC' :class='birdClass'>&nbsp;</div>
  </div>
</template>

<script>
import { initBirds, addBird } from '../lib/my-birds.js'
import { randInt, randNum } from '../lib/randutils.js'

const BIRDS_SVG = require('../assets/birds.svg')

export default {
  props: {
    flightTimeSecs: {
      default: '13',
      type: String
    },
    wingTimeSecs: {
      default: '1',
      type: String
    },
    birdSize: {
      default: '22',
      type: String
    },
    startDelaySecs: {
      default: '0',
      type: String
    },
    y: {
      default: '~400,40',
      type: String
    }
  },
  mounted () {
    initBirds(BIRDS_SVG)

    this.birdnum = addBird({
      noDomInsert: true,
      bottom: this.randCalc(this.y),
      cellWidth: this.randCalc(this.birdSize),
      flapTimeSecs: this.randCalc(this.wingTimeSecs),
      flightTimeSecs: this.randCalc(this.flightTimeSecs),
      startDelaySecs: this.randCalc(this.startDelaySecs),
      opacity: 0.7
    })
  },
  computed: {
    boxClass () {
      return `box_${this.birdnum}`
    },
    birdClass () {
      return `bird_${this.birdnum}`
    }
  },
  methods: {
    randCalc (s) {
      let result = s
      let units = ''

      if (s.indexOf('~') === 0) {
        // ~200,20 -> rand value from 180..220
        const res = s.match(/~([0-9.]+),([0-9.]+)(.*)/)
        const base = parseFloat(res[1])
        const diff = parseFloat(res[2])

        if (res[3]) [,,, units] = res

        result = s.indexOf('.') >= 0
          ? randNum(Math.floor(base - diff), Math.floor(base + diff))
          : randInt(parseInt(base - diff, 10), parseInt(base + diff, 10))
      } else if (s.indexOf('-') >= 0) {
        const res = s.match(/([0-9.]+)-([0-9.]+)/)
        result = s.indexOf('.') >= 0
          ? randNum(res[1], res[2])
          : randInt(parseInt(res[1], 10), parseInt(res[2], 10))
      }
      return result + units
    },
    calc (op, value) {
      // If value is totally numeric
      let conversion = parseFloat(value)
      let units = ''
      if (Number.isNaN(value - conversion)) {
        const matches = /([[0-9.]+)(.*)/.exec(value);
        [, conversion, units] = matches
      }

      return op(conversion) + units
    }
  },
  data () {
    return {
      birdnum: 0
    }
  }
}
</script>

<style lang="less">
</style>




// WEBPACK FOOTER //
// src/components/FlyingBird2.vue